export { default } from "truth-helpers/helpers/lt";
